// Environment determination
const environment = process.env.NODE_ENV || 'development';
const isProduction = environment === 'production';

// Configuration object for browser environment
const config = {
  // React app configuration
  reactApp: {
    apiUrl: process.env.REACT_APP_API_URL || undefined,
  },

  // Environment info
  env: {
    isProd: isProduction,
    environment,
  },

  sentry: {
    dsn: process.env.REACT_APP_SENTRY_DSN || '',
  },
};

// Validate required configuration
const validateConfig = () => {
  const missingKeys: string[] = [];

  // Check reactApp.apiUrl
  if (!config.reactApp.apiUrl) {
    missingKeys.push('reactApp.apiUrl');
  }

  if (missingKeys.length > 0) {
    const errorMsg = `Missing required configuration: ${missingKeys.join(', ')}`;
    console.error(errorMsg);

    // In production, we'll throw an error
    if (isProduction) {
      throw new Error(errorMsg);
    }
  }
};

// Validate on startup
validateConfig();

export default config;
